var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.332031 4.0001L6.41613 0L13.3694 4.0001V9.60023H11.6311V4.80012L6.41613 8.00019L0.332031 4.0001Z",
    fill: "#65A0F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88281 9.91312V5.91302L6.41785 8.79994L10.7636 5.91302V9.59995L6.41785 12L1.88281 9.91312Z",
    fill: "#65A0F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.f2319ade55c66df16937382140661ba1.svg";
export { ForwardRef as ReactComponent };